const MealShimmerCard = () => {
  return (
    <div className="bg-white w-full border border-gray-100 rounded-xl p-4 shadow-sm">
      
      {/* Top Title Row */}
      <div className="flex justify-between mb-4 border-b border-gray-100 pb-2">
        <div className="h-5 w-24 bg-gray-200 rounded relative overflow-hidden shimmer"></div>
        <div className="h-5 w-16 bg-gray-200 rounded relative overflow-hidden shimmer"></div>
      </div>

      {/* Image */}
      <div className="w-full h-48 mb-3 bg-gray-200 rounded-lg relative overflow-hidden shimmer"></div>

      {/* Subtitle */}
      <div className="h-4 w-32 bg-gray-200 rounded relative overflow-hidden shimmer mb-4"></div>

      {/* Footer Buttons + Switch */}
      <div className="flex justify-center items-center gap-4 border-t border-gray-100 pt-4">

        {/* Edit */}
        <div className="w-full h-9 bg-gray-200 rounded-md relative overflow-hidden shimmer"></div>

        {/* Delete */}
        <div className="w-full h-9 bg-gray-200 rounded-md relative overflow-hidden shimmer"></div>

        {/* Switch */}
        <div className="w-full h-9 bg-gray-200 rounded-full relative overflow-hidden shimmer"></div>
      </div>
    </div>
  );
};

export default MealShimmerCard;
